// Configuration for Walkmore.uk application
// Values are set during build time by GitHub Actions deployment using repository variables
const config = {
  apiGateway: {
    REGION: process.env.REACT_APP_AWS_REGION || "eu-west-2",
    URL: process.env.REACT_APP_API_GATEWAY_URL
  },
  cognito: {
    REGION: process.env.REACT_APP_AWS_REGION || "eu-west-2",
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN
  },
  cloudfront: {
    DOMAIN_NAME: process.env.REACT_APP_CLOUDFRONT_DOMAIN || "walkmore.uk"
  },
  features: {
    SIGNUP_ENABLED: process.env.REACT_APP_SIGNUP_ENABLED !== "false"
  }
};

export default config;
